import { render } from "./OrderSuccess.vue?vue&type=template&id=0e7f5548&scoped=true"
import script from "./OrderSuccess.vue?vue&type=script&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&lang=js"

import "./OrderSuccess.vue?vue&type=style&index=0&id=0e7f5548&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7f5548"]])

export default __exports__